import { render, staticRenderFns } from "./SocialRadarEchart.vue?vue&type=template&id=1d487daa&scoped=true&"
import script from "./SocialRadarEchart.vue?vue&type=script&lang=js&"
export * from "./SocialRadarEchart.vue?vue&type=script&lang=js&"
import style0 from "./SocialRadarEchart.vue?vue&type=style&index=0&id=1d487daa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d487daa",
  null
  
)

export default component.exports